import * as _ from "underscore";
import {ILocalesArray} from "../interfaces/locales-array.definition";
import {isUndefined} from "util";

const KEY_NAME = "name";
const KEY_DESCRIPTION = "description";


export class LocalesUtils {

  locale:string='ru';

  constructor() {
    var loc = localStorage.getItem("locale");
    if (loc != null)
    {
      this.locale = loc;
    }
  }


  findName(doc:any): string {
    return this.findValue(KEY_NAME, doc);
  }


  findDescription(doc:any): string {
    return this.findValue(KEY_DESCRIPTION, doc);
  }


  findValue(key: string,
            doc:any) {
    if (this.isLocalized(doc))
    {
      var locales:ILocalesArray = doc['locales'][this.locale];

      if (!_.isArray(locales)) {
        return `locales: is not an array!`;
      }

      for (let i = 0; i < locales.length; ++i) {
        if (locales[i].key === key) {
          if (!_.isArray(locales[i].value)) {
            return `locales: value is not an array!`;
          }
          return locales[i].value[0];
        }
      }
      return `locales: no such key`;
    }
    else
    {
      return `locales: not localized`;
    }
  }

  getLocale():string
  {
    return this.locale;
  }

  setLocale(val:string)
  {
    this.locale = val;
    localStorage.setItem("locale", val);
  }

  isLocalized(doc:any)
  {
    return !isUndefined(doc['locales']);
  }
}


export const localeUtils = new LocalesUtils();



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/locale-utils.ts